import { render, staticRenderFns } from "./AddPropertiesPaymentComponent.vue?vue&type=template&id=7aac18d5"
import script from "./AddPropertiesPaymentComponent.vue?vue&type=script&lang=js"
export * from "./AddPropertiesPaymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports